import { createSlice } from '@reduxjs/toolkit';

type LiveChatState = {
  liveChatVisibility: 'hidden' | 'maximized';
};

const initialState: LiveChatState = {
  liveChatVisibility: 'hidden',
};

const liveChatSlice = createSlice({
  name: 'liveChat',
  initialState,
  reducers: {
    toggleLiveChatVisibility: (state) => {
      state.liveChatVisibility = 'maximized';
    },
  },
});

export const { toggleLiveChatVisibility } = liveChatSlice.actions;
export default liveChatSlice.reducer;
